export default __webpack_public_path__ + "static/media/phishing-logo.1450f024.svg";